import { useEffect } from "react"
import { setSEOIndexOff } from "../../utils/functions"

// import { Container } from './styles';

export default function Logout({ history, location }) {
  useEffect(() => {
    setSEOIndexOff()

    const redirectLoginPath =
      (location && location.state && location.state.redirectLoginPath) || "/"

    localStorage.clear()
    history.push(redirectLoginPath)
  }, [history, location])

  return null
}
